import React from 'react';
import { useTranslation } from 'react-i18next';
import { CarModel } from 'models/StockModel';
import {
    Card,
    CardContent,
    CardHeader,
    Grid,
} from '@mui/material';
import Currency from 'components/formaters/Currency';
import { InvoiceLink, InvoiceDate } from 'modules/invoices/common/Components';


type InvoiceCardProps = {
    car: CarModel,
}

const InvoiceCard = ({car}: InvoiceCardProps) => {
    const {t} = useTranslation('cars');

    if (!car.invoices.length) return null;

    return (
        <Card sx={{mb: 2}}>
            <CardHeader
                title={t('invoices')}
            />
            <CardContent>
                {car.invoices.map(i => (
                    <Grid container key={i.number}>
                        <Grid item xs={4}>
                            <InvoiceLink invoice={i}/>
                        </Grid>
                        <Grid item xs={8}>
                            <InvoiceDate invoice={i}/>
                        </Grid>
                    </Grid>
                ))}

                {car.prices?.main.total && (
                    <Grid container>
                        <Grid item xs={4}>
                            {t('freight')}: <Currency
                                value={car.prices?.meta.freight + (car.prices?.meta.vehicle_type || 0)}
                                currency="usd"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            {t('rate')}: <Currency value={car.prices?.meta.rate}/>
                        </Grid>
                        <Grid item xs={4}>
                            {t('total')}: <Currency value={car.prices?.main.total}/>
                        </Grid>
                    </Grid>
                )}

                {car.prices?.secondary.total && (
                    <Grid container>
                        <Grid item xs={4}>
                            {t('freight')}: <Currency
                                value={car.prices?.secondary.total}
                                currency="usd"
                            />
                        </Grid>
                    </Grid>
                )}

            </CardContent>
        </Card>
    );
};

export default InvoiceCard;
